import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'

import {
   BoxContainerLighter,
   H2,
   H4,
   CustomRadioBtn,
   Label,
   TimePicker
} from '@welcom/esg-react-components'
import { Statusbar } from '../components/Statusbar'
import { AppContext } from '../appState'

const AlignLeft = styled.div`
   text-align: left;
`

const RadioWrapper = styled.div`
   display: inline-flex;
   margin-right: 20px;
   margin-bottom: 20px;
   label {
      display: flex;
      align-items: center;
   }
`
const TimeSelectWrapper = styled.div`
   display: inline-flex;
   flex-direction: column;
   margin-right: 20px;
`

export const Fritids = () => {
   const { store, dispatch, setDisableNext } = useContext(AppContext)

   /* Set default times for drop off and pick up */
   useEffect(() => {
      if (!store.fritids.dropOff) {
         dispatch({
            type: 'updateFritids',
            key: 'dropOff',
            value: '07:30'
         })
      }

      if (!store.fritids.pickUp) {
         dispatch({
            type: 'updateFritids',
            key: 'pickUp',
            value: '17:30'
         })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!store.fritids.fritids) {
         setDisableNext(false)
      } else if (
         store.fritids.fritids &&
         store.fritids.dropOff &&
         store.fritids.pickUp
      ) {
         setDisableNext(false)
      } else {
         setDisableNext(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [store.fritids])

   return (
      <AlignLeft>
         <BoxContainerLighter>
            <Statusbar currentStep={3} />
            <H2>4. Fritids</H2>
            <p>Do you want fritids for your child?</p>
            <div>
               <RadioWrapper>
                  <Label htmlFor={'no'}>
                     <CustomRadioBtn
                        onChange={e => {
                           dispatch({
                              type: 'updateFritids',
                              key: 'fritids',
                              value: false
                           })
                        }}
                        type={'radio'}
                        value={0}
                        id={'no'}
                        name={'fritids'}
                        label={'No'}
                     />
                     No{' '}
                  </Label>
               </RadioWrapper>

               <RadioWrapper>
                  <Label htmlFor={'yes'}>
                     <CustomRadioBtn
                        onChange={e => {
                           dispatch({
                              type: 'updateFritids',
                              key: 'fritids',
                              value: true
                           })
                        }}
                        checked={store.fritids.fritids ?? false}
                        type={'radio'}
                        value={1}
                        id={'yes'}
                        name={'fritids'}
                        title={'Yes'}
                     />
                     Yes
                  </Label>
               </RadioWrapper>
            </div>

            {store.fritids.fritids && (
               <>
                  <H4>Fritids hours</H4>
                  <p>
                     Our normal fritids hours are 7.30 until 17.30. What hours
                     does your child need?
                  </p>
                  <TimeSelectWrapper>
                     <Label>Drop off</Label>
                     <TimePicker
                        durationInMinutes={15}
                        endTime="15:00"
                        pickedTime={store.fritids.dropOff ?? undefined}
                        onChange={value => {
                           dispatch({
                              type: 'updateFritids',
                              key: 'dropOff',
                              value: value
                           })
                        }}
                        startTime="07:30"
                     />
                  </TimeSelectWrapper>
                  <TimeSelectWrapper>
                     <Label>Pick up</Label>
                     <TimePicker
                        durationInMinutes={15}
                        endTime="17:30"
                        pickedTime={store.fritids.pickUp ?? undefined}
                        onChange={value => {
                           dispatch({
                              type: 'updateFritids',
                              key: 'pickUp',
                              value: value
                           })
                        }}
                        startTime={store.fritids.dropOff ?? '11:00'}
                     />
                  </TimeSelectWrapper>
               </>
            )}
         </BoxContainerLighter>
      </AlignLeft>
   )
}
